import React from 'react';
import LoginUI from './LoginUI';

const LoginContainer = () => (<LoginUI />);

LoginContainer.displayName = 'LoginContainer';

export default LoginContainer;
